export default {
  default: {
    title: 'End User Terms',
    paragraph: "By using Product Data, you confirm that you have read and accepted CoreLogic's End User Terms for the access and use of the Product Data.",
  },
}
